import {invoiceConstants} from '../constants';
import {request} from '../services/request';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';

const errorHandlerProps = {disableAlert: true};

const getInvoices = (query = null, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_INVOICES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getInvoice = (id, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_INVOICE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getAccountingInvoice = (id, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_ACCOUNTING_INVOICE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBatchInvoices = ({data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_INVOICES_BATCH,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const batchCreateInvoices = (data, successCallback, errorCallback) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_INVOICES_BATCH_CREATE,
      data,
      successCallback,
      errorCallback,
    });
  }
}

const batchDeleteInvoices = (invoices, successCallback, errorCallback) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: backendEndpoints.DELETE_INVOICES_BATCH,
      successCallback,
      errorCallback,
      data: {invoices}
    });
  }
}

const getInvoicesTotal = (successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_INVOICES_STATS,
      successCallback,
      errorCallback,
    });
  }
}

const getInvoicesTotalUnmatched = (successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_INVOICES_STATS_UNMATCHED,
      successCallback,
      errorCallback
    });
  }
}

const updateInvoice = (id, data, successCallback, errorCallback) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_INVOICE_UPDATE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const linkExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_INVOICE_LINK_EXPENSE, {id}),
      data,
      successCallback,
      errorCallback,
    });
  }
}

const unlinkExpense = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_INVOICE_UNLINK_EXPENSE,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadAccountingInvoice = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_ACCOUNTING_INVOICE_ATTACHMENT, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadInvoice = (id, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_INVOICE_ATTACHMENT, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadZipInvoices = (query, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_DOWNLOAD_ZIP_INVOICES,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getInvoiceNeighbours = ({id, query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_INVOICE_NEIGHBOURS, {id}),
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getInvoiceRelatedExpenses = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.GET_INVOICE_RELATED_EXPENSES, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const payInvoiceOutside = ({id, paid = true, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      data: {paid_outside: paid},
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_INVOICE_PAID_OUTSIDE, {id}),
      successCallback,
      errorCallback,
    });
  }
}

const saveInvoicesListUrl = (url, query) => {
  return (dispatch) => {
    dispatch({ type: invoiceConstants.SAVE_INVOICES_LIST_URL, payload: { url, query } })
  }
}

export const invoicesActions = {
  getInvoice,
  getInvoices,
  getInvoiceNeighbours,
  getInvoiceRelatedExpenses,
  getInvoicesTotal,
  getInvoicesTotalUnmatched,
  getAccountingInvoice,
  getBatchInvoices,
  batchCreateInvoices,
  batchDeleteInvoices,
  downloadAccountingInvoice,
  downloadInvoice,
  downloadZipInvoices,
  linkExpense,
  payInvoiceOutside,
  saveInvoicesListUrl,
  unlinkExpense,
  updateInvoice,
};
